import React from 'react'
import Container, { Item } from './items.styles'
import Text from '../../../atoms/Text/Text'
import TrashSvg from '../../../atoms/Icons/General/Trash'
import Spinner from '../../../atoms/Icons/deprecatedIcons/spinner/spinner'

export type ShoppingCartItem = {
  count: number
  title: string
  descriptions: string[]
  price: number
  id: string
  isLoading?: boolean
}

type Props = {
  items: ShoppingCartItem[]
  onRemoveItem?: (id: string) => void
}

const formatPrice = (price: number) => {
  const hasNoRest = price % 1 === 0
  const formattedPrice = hasNoRest ? `${price},00` : `${price}`
  return formattedPrice.replace('.', ',')
}

const Items: React.FunctionComponent<Props> = ({ items, onRemoveItem }) => {
  const getRemoveFromCartComponent = (item: ShoppingCartItem) => {
    if (!onRemoveItem) return null

    if (item.isLoading) return <span className="spinner"><Spinner /></span>
    
    // istanbul ignore else
    if (!item.isLoading) {
      return (
        <span className="delete" data-testid="removeProduct" onClick={() => onRemoveItem(item.id)}>
          <TrashSvg />
        </span>
      )
    }
  }

  return (
    <Container>
      {items.map(item => (
        <article key={item.title}>
          <Item>
            <span className="count">{item.count}x</span>
            <span className="title">
              {item.title}
              <ol className="description">
                {item.descriptions.map(description => (
                  <li className="item" key={description}>
                    {description}
                  </li>
                ))}
              </ol>
            </span>
            {getRemoveFromCartComponent(item)}
            <Text className="price" size="large">
              &euro;{formatPrice(item.price)}
            </Text>
          </Item>
        </article>
      ))}
    </Container>
  )
}

export default Items
